import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { documentTypes, DOCUMENT_TAGS } from "@/js/lists.ts";
import { ERROR_DATA, getErrorData, handleErrorData } from "@/js/forms.js";
import ManageDocumentsTagsDialog from "@/components/document-tags/ManageDocumentsTagsDialog.vue";
import AddTagToDocumentDialog from "@/components/document-tags/AddTagToDocumentDialog.vue";
import confirmationComponent from "@/components/modal/ConfirmationDialog.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
import UploaderV2 from "@/components/default/UploaderV2.vue";
export default {
  name: "PurchaseOrderAttachedFilesDrawer",
  props: {
    id: {
      type: Number,
      required: false
    }
  },
  components: {
    ManageDocumentsTagsDialog: ManageDocumentsTagsDialog,
    AddTagToDocumentDialog: AddTagToDocumentDialog,
    UploaderV2: UploaderV2,
    Confirm: confirmationComponent,
    ErrorModal: ErrorModal
  },
  data: function data() {
    return {
      drawer: false,
      isMakingDrawerStateless: false,
      files: [],
      isLoadingFiles: false,
      isStatelessDrawer: false,
      gettingDocumentTags: {
        isPending: false,
        cancellationToken: null,
        results: []
      },
      uploadAdditionalData: {
        tagId: null
      },
      documentTypes: documentTypes,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    uploadUrl: function uploadUrl() {
      return "".concat(process.env.VUE_APP_API_URL, "/v1/uploader/purchase-orders/").concat(this.id, "/files");
    },
    uploadAdditionalFormData: function uploadAdditionalFormData() {
      return _objectSpread({}, this.uploadAdditionalData);
    }
  },
  methods: {
    openDrawer: function openDrawer() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this2.drawer = true;
              _this2.fetchPurchaseOrderFiles();
              _this2.fetchDocumentTags();
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    closeDrawer: function closeDrawer() {
      this.drawer = false;
    },
    openTagsDialog: function openTagsDialog() {
      this.$refs.ManageDocumentsTagsDialog.openDialog();
    },
    openAddTagToDocument: function openAddTagToDocument(idDocument) {
      this.$refs.AddTagToDocumentDialog.openDialog(idDocument, this.documentTypes.PURCHASE_ORDER);
    },
    fetchPurchaseOrderFiles: function fetchPurchaseOrderFiles() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this = _this3;
              _this3.isLoadingFiles = true;
              _context2.next = 4;
              return request("/v1/purchase-orders/".concat(_this3.id, "/files"), "get", null, true, "api", null, _this3.filesCancelToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.$toasted.show("Unable to load files.", {
                    type: "error"
                  });
                  _this.isLoadingFiles = false;
                  throw e;
                }
              });
            case 4:
              response = _context2.sent;
              if (response) _this3.files = _toConsumableArray(response.data);
              _this3.isLoadingFiles = false;
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    removeTagFromDocument: function removeTagFromDocument(idDocument) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this = _this4;
              _this.$refs.confirm.open("Delete", "Are you sure you want to delete this tag ?", {
                color: "red"
              }).then(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(confirm) {
                  return _regeneratorRuntime().wrap(function _callee3$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        if (!confirm) {
                          _context3.next = 3;
                          break;
                        }
                        _context3.next = 3;
                        return request("/v1/document-tags/type/".concat(_this.documentTypes.PURCHASE_ORDER.id), "delete", {
                          idDocument: idDocument
                        }, true, "api").then(function (response) {
                          _this.tagListChangedUpdate();
                        }).catch(function (error) {
                          _this.$toasted.show("Unable to remove tag from document.", {
                            type: "error"
                          });
                          throw error;
                        });
                      case 3:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    upload: function upload() {
      this.fetchPurchaseOrderFiles();
      this.uploadAdditionalData.tagId = null;
    },
    removeFile: function removeFile(fileId) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var confirmed, _this;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this5.isStatelessDrawer = true;
              _context5.next = 3;
              return _this5.$refs.confirm.open("Cancel", "Are you sure you want to remove this file?", {
                color: "red"
              });
            case 3:
              confirmed = _context5.sent;
              if (!confirmed) {
                _context5.next = 10;
                break;
              }
              _this5.isLoadingFiles = true;
              _this = _this5;
              _context5.next = 9;
              return request("/v1/purchase-orders/".concat(_this5.id, "/files/").concat(fileId), "delete", null, true, "api").catch(function (e) {
                _this.$toasted.show("Unable to remove this file.", {
                  type: "error"
                });
                _this.isLoadingFiles = false;
                throw e;
              });
            case 9:
              _this5.fetchPurchaseOrderFiles();
            case 10:
              _this5.digestStatelessDrawer();
            case 11:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    tagListChangedUpdate: function tagListChangedUpdate() {
      this.fetchPurchaseOrderFiles();
      this.fetchDocumentTags();
      this.$refs.AddTagToDocumentDialog.fetchDocumentTags();
      this.$refs.ManageDocumentsTagsDialog.fetchDocumentTags();
    },
    fetchDocumentTags: function fetchDocumentTags() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this6$gettingDocumen;
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this6.gettingDocumentTags.isPending = true;
              (_this6$gettingDocumen = _this6.gettingDocumentTags.cancellationToken) === null || _this6$gettingDocumen === void 0 || _this6$gettingDocumen.cancel();
              _this6.gettingDocumentTags.cancellationToken = axios.CancelToken.source();
              _this = _this6;
              _context6.next = 6;
              return request("/v1/document-tags/all", "get", null, true, "api", null, _this.gettingDocumentTags.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, "Unable to get list of tags", true);
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 6:
              response = _context6.sent;
              _this6.gettingDocumentTags.results = _toConsumableArray(response.data.items);
              _this6.gettingDocumentTags.results = _this6.gettingDocumentTags.results.filter(function (x) {
                return x.id !== DOCUMENT_TAGS.ORDER_FINAL_INVOICE.tagId;
              });
              _this6.gettingDocumentTags.isPending = false;
            case 10:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    openUrl: function openUrl(url) {
      window.open(url, "_blank");
    },
    digestStatelessDrawer: function digestStatelessDrawer() {
      var _this = this;
      setTimeout(function () {
        return _this.isStatelessDrawer = false;
      }, 1000);
    }
  }
};